export default function raceGuard<T>(
  provider: () => Promise<T>
): (force?: boolean) => Promise<T> {
  let lastRequest: Promise<T> | undefined;
  let lastRequestVersion = 0;
  let lastValue: T | undefined;
  let valueVersion = 0;
  return (force = false): Promise<T> => {
    if (force || lastRequest === undefined) {
      lastRequestVersion += 1;
      lastRequest = provider();
    }
    const requestVersion = lastRequestVersion;
    return new Promise((resolve, reject) => {
      if (lastRequest == null) {
        reject(new Error("INTERNAL ERRROR: lastPromise shouldn't be null"));
        return;
      }
      lastRequest
        .then((value) => {
          if (requestVersion > valueVersion) {
            lastValue = value;
            valueVersion = requestVersion;
          }
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          resolve(lastValue!);
        })
        .catch((error) => {
          if (requestVersion === lastRequestVersion || valueVersion === 0) {
            reject(error);
          } else {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            resolve(lastValue!);
          }
        })
        .finally(() => {
          if (requestVersion === lastRequestVersion) {
            lastRequest = undefined;
          }
        });
    });
  };
}
